import * as React from "react";
const SvgFiRrKidneys = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-kidneys_svg__a)">
      <path
        fill="#062147"
        d="M9.311 7.897c1.689-1.324 2.202-3.75 1.112-5.679A4.33 4.33 0 0 0 7.766.15a4.28 4.28 0 0 0-3.295.442C1.175 2.521 0 5.683 0 8.001c0 2.127.141 3.456.905 4.81a4.23 4.23 0 0 0 3.709 2.181c.741 0 1.503-.19 2.223-.59A4.4 4.4 0 0 0 8.964 11.2q.036.226.036.457V23a1 1 0 0 0 2 0V11.657c0-1.335-.52-2.59-1.464-3.535zm-1.613-1.33c-1.572.856-1.395 2.03-.97 2.862.589 1.154.186 2.61-.943 3.27a2.29 2.29 0 0 1-3.138-.874c-.501-.886-.646-1.744-.646-3.825 0-1.762.915-4.18 3.48-5.682a2.3 2.3 0 0 1 1.765-.238c.61.165 1.12.563 1.437 1.123.654 1.157.149 2.702-.984 3.365zM19.529.591a4.28 4.28 0 0 0-3.295-.443 4.33 4.33 0 0 0-2.657 2.07c-1.09 1.927-.577 4.354 1.112 5.678l-.225.225A4.97 4.97 0 0 0 13 11.656V23a1 1 0 0 0 2 0V11.656q0-.23.036-.456c.18 1.3.924 2.496 2.12 3.196.009.005.998.61 2.214.61a4.27 4.27 0 0 0 3.725-2.197C23.86 11.456 24 10.13 24 8c0-2.317-1.174-5.48-4.471-7.409zm1.825 11.234c-.632 1.116-2.01 1.501-3.181.85-1.085-.636-1.489-2.09-.899-3.246.425-.833.601-2.006-.972-2.862-1.133-.664-1.638-2.208-.983-3.364.316-.56.827-.958 1.437-1.123a2.3 2.3 0 0 1 1.765.238c2.566 1.501 3.48 3.92 3.48 5.682 0 2.081-.146 2.94-.647 3.825"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-kidneys_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKidneys;
